<script setup lang="ts">

import { faEdit, faPlus, faTrashCan, faXmark } from '@fortawesome/pro-regular-svg-icons'

import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useLessonsControls } from '../../model/lessons/lessons-controls.hook'

defineOptions({
  name: 'LessonsControls',
})

const props = withDefaults(defineProps<{
  disabled?: boolean
}>(), {
  disabled: false,
})

const {
  refIsShown,
  refHasSelection,
  refSelectedCount,
  refCanDelete,
  refIsDeal,
  refIsBulkEditDisabled,
  refBulkEditHint,
  refIsDeleteSelectedDisabled,
  refDeleteSelectedHint,
  refIsCancelReservedDisabled,
  refCancelReservedHint,
  refAddLessonUrl,
  loadingHint,
  openDeleteSelected,
  openDeleteReserved,
  openBulkEdit,
} = useLessonsControls({ isLoading: toRef(props, 'disabled') })
</script>

<template>
  <div
    v-if="refIsShown"
    class="lessons-controls"
  >
    <template v-if="refHasSelection">
      <AppTooltip
        :text="refBulkEditHint"
        mode="disabled"
      >
        <BtnSecondary
          :text="`Bulk edit ${refSelectedCount}`"
          :disabled="refIsBulkEditDisabled"
          @click="openBulkEdit"
        >
          <template #iconLeft>
            <AppIcon :icon="faEdit" />
          </template>
        </BtnSecondary>
      </AppTooltip>
      <AppTooltip
        v-if="refCanDelete"
        :text="refDeleteSelectedHint"
        mode="disabled"
      >
        <BtnPrimary
          :text="`Delete ${refSelectedCount}`"
          color="red"
          :disabled="refIsDeleteSelectedDisabled"
          @click="openDeleteSelected"
        >
          <template #iconLeft>
            <AppIcon :icon="faTrashCan" />
          </template>
        </BtnPrimary>
      </AppTooltip>
    </template>
    <template v-else>
      <AppTooltip
        v-if="refIsDeal && refCanDelete"
        :text="refCancelReservedHint"
        mode="disabled"
      >
        <BtnSecondary
          text="Cancel reserved"
          :disabled="refIsCancelReservedDisabled"
          @click="openDeleteReserved"
        >
          <template #iconLeft>
            <AppIcon :icon="faXmark" />
          </template>
        </BtnSecondary>
      </AppTooltip>
      <AppTooltip
        :text="loadingHint"
        mode="disabled"
      >
        <BtnPrimary
          text="Add lesson"
          color="emerald"
          :to="refAddLessonUrl"
          :disabled="disabled"
        >
          <template #iconLeft>
            <AppIcon :icon="faPlus" />
          </template>
        </BtnPrimary>
      </AppTooltip>
    </template>
  </div>
</template>

<style scoped lang="scss" src="./LessonsControls.scss" />
